import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface Employee {
    id: number;
    name: string;
    hasNoMobileForAttendance?: boolean;
    autoAttendance?: boolean;
    incentiveOnGlobalSales?: boolean;
}

@Injectable({ providedIn: 'root' })
export class EmployeeService {

    constructor(private http: HttpClient) { }

    getAll(companyId?: string, branchId?: string): Observable<Employee[]> {
        const queryParts: string[] = [];

        if (companyId) {
            queryParts.push(`companyId=${encodeURIComponent(companyId)}`);
        }

        if (branchId) {
            queryParts.push(`branchId=${encodeURIComponent(branchId)}`);
        }

        const query = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
        return this.http.get<Employee[]>(`${environment.apiUrl}/Employees${query}`);
    }

    getById(id: number): Observable<Employee> {
        return this.http.get<Employee>(`${environment.apiUrl}/Employees/${id}`);
    }

    getByName(name: string): Observable<Employee> {
        return this.http.get<Employee>(`${environment.apiUrl}/Employees/GetByName/${name}`);
    }

    update(id: number, employee: Employee): Observable<Employee> {
        return this.http.put<Employee>(`${environment.apiUrl}/Employees/${id}`, employee);
    }
}
